import StarSvg from '@/components/Icon/svgs/Star_AI.svg';
import FriendsSvg from '@/components/Icon/svgs/friend.svg';
import HomeSvg from '@/components/Icon/svgs/home_fill.svg';
import SearchSvg from '@/components/Icon/svgs/search.svg';
import { EGlobalId } from '@/types/common';
import { ROUTER_PATH } from '@/utils/router';

export enum ViewTabsEnum {
  Search = 'memories',
  Home = 'home',
  Friends = 'friends',
  Talks = 'talks'
}

export const PATabs = [
  ViewTabsEnum.Home,
  ViewTabsEnum.Friends,
  ViewTabsEnum.Talks,
  ViewTabsEnum.Search
];

export const ViewTabsEnumRouterMap = {
  [ViewTabsEnum.Search]: ROUTER_PATH.personalAIMemory,
  [ViewTabsEnum.Home]: ROUTER_PATH.personalAI,
  [ViewTabsEnum.Talks]: ROUTER_PATH.talks,
  [ViewTabsEnum.Friends]: ROUTER_PATH.friends
};

export const ViewTabsEnumMobileRouterMap = {
  [ViewTabsEnum.Search]: ROUTER_PATH.personalAIMemoryMobile,
  [ViewTabsEnum.Home]: ROUTER_PATH.personalAIMobile,
  [ViewTabsEnum.Talks]: ROUTER_PATH.talksMobile,
  [ViewTabsEnum.Friends]: ROUTER_PATH.friendsMobile
};

export const ViewTabsNameMap = {
  [ViewTabsEnum.Search]: 'Search',
  [ViewTabsEnum.Home]: 'Home',
  [ViewTabsEnum.Talks]: 'Talks',
  [ViewTabsEnum.Friends]: 'Friends'
};

export const ViewTabsNameTranslationMap = {
  [ViewTabsEnum.Search]: 'leftTabs.search',
  [ViewTabsEnum.Home]: 'leftTabs.home',
  [ViewTabsEnum.Talks]: 'leftTabs.aiCreation',
  [ViewTabsEnum.Friends]: 'leftTabs.friends'
};

export const ViewTabsIdMap = {
  [ViewTabsEnum.Search]: EGlobalId.MENU_TAB_MEMORY,
  [ViewTabsEnum.Home]: EGlobalId.MENU_TAB_HOME,
  [ViewTabsEnum.Talks]: EGlobalId.MENU_TAB_AGENT,
  [ViewTabsEnum.Friends]: EGlobalId.MENU_TAB_FRIENDS
};

export const TabIconMap = {
  [ViewTabsEnum.Search]: SearchSvg,
  [ViewTabsEnum.Home]: HomeSvg,
  [ViewTabsEnum.Talks]: StarSvg,
  [ViewTabsEnum.Friends]: FriendsSvg,
  default: HomeSvg
};

export function newTabItem(v: ViewTabsEnum): TabItem {
  return {
    key: v,
    id: ViewTabsIdMap[v],
    name: ViewTabsNameMap[v]
  };
}

export const ViewTabsList = Object.values(ViewTabsEnum);

// export const PATabItems = isTrulyProd()
//   ? PATabs.map(newTabItem).filter((item) => item.key !== ViewTabsEnum.Friends)
//   : PATabs.map(newTabItem);

export const PATabItems = PATabs.map(newTabItem);

export interface TabItem {
  key: ViewTabsEnum;
  name: string;
  id: string;
  onItemClick?: () => void;
}

export enum LayoutSecondaryPanelEnum {
  iosPhone = 'iosPhone',
  androidPhone = 'androidPhone',
  bring = 'bring',
  subscription = 'subscription',
  brainMap = 'brainMap',
  apiKey = 'apiKey',
  NULL = ''
}
